import Amplify from 'aws-amplify'
import config from 'App/AmplifyConfig/config'

Amplify.configure(config)

export default ({ children }) => {
  return children
}
